"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setFitPayBankAccountDummy = setFitPayBankAccountDummy;
var payment_const_1 = require("@src/modules/fitfms/membership-completion/const/payment.const");
var lodash_1 = __importDefault(require("lodash"));
function setFitPayBankAccountDummy(config, allData) {
    var _a, _b, _c;
    lodash_1.default.set(allData, 'data.customer.bankAccount', lodash_1.default.cloneDeep(payment_const_1._FakeIBAN));
    if ((_b = (_a = config.get.stripe) === null || _a === void 0 ? void 0 : _a.bankAccountHolder) === null || _b === void 0 ? void 0 : _b.length) {
        lodash_1.default.set(allData, 'data.customer.bankAccount.accountHolder', (_c = config.get.stripe) === null || _c === void 0 ? void 0 : _c.bankAccountHolder);
    }
}
